import { Component, computed, effect, signal, Signal, WritableSignal, inject } from '@angular/core';
import { PaysCheckboxComponent } from '../../../../shared/components/forms/pays-checkbox/pays-checkbox.component';
import { ActivatedRoute } from '@angular/router';
import { RegisterService } from '../../../../_services/register-service/register.service';
import { Store } from '@ngxs/store';
import { GoToStep } from '../../../../store/onboarding/onboarding.actions';
import { OnboardingSteps } from '../../../../store/onboarding/onboarding.model';
import { environment } from '../../../../../environments/environment';
import { DirectorApproval, DirectorApprovalDetail } from '../../../../_interfaces/director-approval.interface';
import { LoaderComponent } from '../../../../shared/components/loader/loader.component';

@Component({
  selector: 'app-director-approval',
  imports: [PaysCheckboxComponent, LoaderComponent],
  templateUrl: './director-approval.component.html',
})
export class DirectorsApprovalComponent {
  readonly registerService = inject(RegisterService);
  readonly route = inject(ActivatedRoute);
  readonly store = inject(Store);

  adminName: string = '';
  businessName: string = '';
  chkBoxLabel: Signal<string> = computed<string>(
    () =>
      `I hereby agree that I am a director of ${this.businessName} and authorise for ${this.adminName} to register the company.`,
  );
  chkBoxValue: boolean = false;
  success: WritableSignal<boolean> = signal(false);
  alreadyApproved: WritableSignal<boolean> = signal(false);
  valid: WritableSignal<boolean> = signal(false);
  loading: WritableSignal<boolean> = signal(true);
  websiteBaseUrl = environment.websiteBaseUrl;

  constructor() {
    this.registerService.directorApprovalValidation(this.formData).subscribe({
      next: (data: DirectorApprovalDetail) => {
        this.loading.set(false);
        this.valid.set(true);
        this.businessName = data.biz;
        this.adminName = data.admin;
      },
      error: (err) => {
        this.loading.set(false);
        if (err.error.non_field_errors?.length && err.error.non_field_errors[0].includes('Director already approved')) {
          this.alreadyApproved.set(true);
        } else {
          this.valid.set(false);
          this.success.set(false);
        }
      },
    });
    effect(() => {
      if (this.success()) {
        this.store.dispatch(new GoToStep(OnboardingSteps.SUCCESS));
      } else {
        this.store.dispatch(new GoToStep(OnboardingSteps.DIRECTOR_APPROVAL));
      }
    });
  }

  get formData(): DirectorApproval {
    const params = this.route.snapshot.queryParams;
    return {
      business_id: params['biz_id'],
      code: params['code'],
      director_id: params['director_id'],
    };
  }

  onSubmit() {
    this.registerService.directorApproval(this.formData).subscribe({
      next: () => {
        this.success.set(true);
      },
      error: () => {
        this.success.set(false);
      },
    });
  }

  disabledBtn() {
    return !this.chkBoxValue;
  }
}
